import z from 'zod';

export const anredeValues = ['Frau', 'Herr', 'divers'];

export const PersoenlichesSchema = z.object({
  anrede: z.string().refine((value) => anredeValues.includes(value), {
    message: 'Bitte auswählen',
  }),
  vorname: z
    .string()
    .min(1, 'Feld darf nicht leer sein')
    .max(50, 'Maximale Länge sind 50 Zeichen'),
  nachname: z
    .string()
    .min(1, 'Feld darf nicht leer sein')
    .max(50, 'Maximale Länge sind 50 Zeichen'),
});
